import { Injectable } from '@angular/core'
import { EnvironmentService } from 'framework/environment/environment.service'

export interface Modal {
    title: string
    content: string
}

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    constructor(private environmentService: EnvironmentService) {}

    getModal(keys: string[]): Modal | false {
        let modal: Modal | false = false

        if (this.environmentService.environment.modals && this.environmentService.environment.modals.length) {
            const matchingModals = this.environmentService.environment.modals.filter(modal =>
                keys.includes(modal.modalKey)
            )

            if (matchingModals.length) {
                modal = {
                    title: matchingModals[0].modalTitle,
                    content: matchingModals[0].modalContent,
                }
            }
        }

        return modal
    }
}
